import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faInfoCircle,
  faUser,
  faIndustry,
  faRocket,
  faLightbulb,
  faMapMarkedAlt,
  faPhoneSquareAlt,
  faFax,
  faMobileAlt,
  faEnvelope,
  faExternalLinkSquareAlt,
} from "@fortawesome/free-solid-svg-icons";
function CompanyAbout() {
  return (
    <>
      <div className="company__detailes">
        <div className="company__detailes__left">
          <div className="boxShadow">
            <p className="p-icon">
              <FontAwesomeIcon icon={faInfoCircle} size="lg" /> Almarai Company
              is a Saudi multinational dairy company which is listed on the
              Tadawul stock exchange. It specializes in food and beverage
              manufacturing and distribution. The company's main offices are
              located in Riyadh, Saudi Arabia,
            </p>
          </div>
          <div className="boxShadow">
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faUser} size="lg" />
              <strong>Commercial Name: </strong>
              Al Marai
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faIndustry} size="lg" />
              <strong>Industry: </strong>
              Food Processing
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faRocket} size="lg" />
              <strong>Founded: </strong>
              1977 (44 Years ago)
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faLightbulb} size="lg" />
              <strong>Founders: </strong>
              Sultan bin Mohammed bin Saud Al Kabeer
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faMapMarkedAlt} size="lg" />
              <strong>Headquarters: </strong>
              Riyadh, Saudi Arabia
            </p>
          </div>
        </div>
        <div className="company__detailes__right">
          <div className="boxShadow">
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faInfoCircle} size="lg" />
              <strong>Contact Details</strong>
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faPhoneSquareAlt} size="lg" />
              <strong>Telephone: </strong>
              +966 (11) 470 0005 0005
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faFax} size="lg" />
              <strong>Fax: </strong>
              +966 (11) 470 1555
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faMobileAlt} size="lg" />
              <strong>Mobile: </strong>
              +966 (11) 470 0005
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faEnvelope} size="lg" />
              <strong>Email: </strong>
              info@almarai.com
            </p>
            <p className="p-icon mb-4">
              <FontAwesomeIcon icon={faExternalLinkSquareAlt} size="lg" />
              <strong>Website: </strong>
              <a
                href="https://www.almarai.com"
                target="_blank"
                rel="noreferrer"
              >
                www.almarai.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompanyAbout;
